<div class="banner-background" [ngStyle]="backgroundImageStyle()">
  <div class="banner-container">
    <ng-container [ngSwitch]="getComponentRenderState()">
      <div class="banner-title-loading" *ngSwitchCase="'loading'"></div>
      <h1 *ngSwitchCase="'content'" class="banner-title">
        {{
          'transfer_v2.checkout.banner.title' | translate: bannerTitleParams()
        }}
      </h1>
    </ng-container>
  </div>
</div>
